import { defineAgenda, param } from '@/shared/navigation/core';

/**
 * Založení i editace webového filtru. Bez `webFilterId` = create (vyžaduje `webProjectId` ve state
 * z list scope); s `webFilterId` = edit.
 */
export const webFilterFormAgenda = defineAgenda({
  id: 'app.www.web-filter-form',
  path: 'app/www/web-filter',
  open: {
    webFilterId: param.uuid().optional(),
  },
  state: {
    /** Scope projektu při create — po uložení je FK immutable. */
    webProjectId: param.number().optional(),
  },
  title: 'Filtr zájezdů',
  icon: 'filter',
  presentationHints: {
    shell: {
      layoutMode: 'overlay',
    },
  },
});
